import ScenarioCarousel from "./ScenarioCarousel";

const SavedScenarioPage  = () => {
    return (
        <ScenarioCarousel
            savedOnly
            activeTab=""
            activeSubTab=""
            mapSubTabToTag={() => ""}
        />
    );
};

export default SavedScenarioPage;